module.exports = __webpack_public_path__ + "static/media/summer-salads.7a53b340.pdf";